import React, { useState } from "react";
import SearchInput from "@components/input/SearchInput";
import styled from "@emotion/styled";
// @ts-ignore
import { faker } from "@faker-js/faker";
import SellerCard from "@components/card/SellerCard";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
});

const List = styled.div({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "2.4rem",
  padding: "0rem 2rem 4rem",
});

const InputWrapper = styled.div({
  padding: "1.6rem",
});

const FollowerTab = () => {
  const params = useParams();
  const id = params.userId;

  const [inputValue, setInputValue] = useState("");

  const { getFollowerList } = useApiRequest();
  const { t } = useTranslation();

  const { data: followerList } = useQuery({
    queryKey: ["followerList"],
    queryFn: () => getFollowerList(Number(id)),
    enabled: !!id,
  });

  const filteredList = followerList?.filter((list: any) =>
    list.nickname.toLowerCase().includes(inputValue.toLowerCase()),
  );

  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    return;
  };

  return (
    <Container>
      <InputWrapper>
        <SearchInput
          placeholder={t("팔로워 검색")}
          inputValue={inputValue}
          setInputValue={setInputValue}
          onClick={handleKeyUp}
        />
      </InputWrapper>

      <List>
        {filteredList?.map((item: any) => (
          <SellerCard
            id={item.id}
            name={item.nickname}
            src={item.profile_image}
            follow={item.is_followed === 0 ? false : true}
            is_me={item.is_me === 1}
          />
        ))}
      </List>
    </Container>
  );
};

export default FollowerTab;
